import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@devhop/ui";
import type { RefundReportReasonsItemDTO } from "../api/client";

type RefundReportReasonsTableProps = {
  isLoading: boolean;
  data: RefundReportReasonsItemDTO[];
};

export function RefundReportReasonsTable({
  isLoading,
  data,
}: RefundReportReasonsTableProps) {
  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="min-w-[280px]">ເຫດຜົນ</TableHead>
            <TableHead className="w-[120px] text-right">ຈຳນວນຄັ້ງ</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {isLoading ? (
            <TableRow>
              <TableCell
                colSpan={2}
                className="h-24 text-center text-muted-foreground"
              >
                ກຳລັງໂຫລດ...
              </TableCell>
            </TableRow>
          ) : data.length === 0 ? (
            <TableRow>
              <TableCell
                colSpan={2}
                className="h-24 text-center text-muted-foreground"
              >
                ບໍ່ພົບຂໍ້ມູນໃນຊ່ວງວັນທີ່ເລືອກ
              </TableCell>
            </TableRow>
          ) : (
            data.map((row, idx) => (
              <TableRow key={`${row.reason}-${idx}`}>
                <TableCell className="text-sm">{row.reason || "—"}</TableCell>
                <TableCell className="text-right tabular-nums">
                  {row.count.toLocaleString()}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
}
